<template>
  <v-list-item class="abstract-place__container" v-on="$listeners" :disabled="disabled">
    <v-btn fab small :color="btnColor" elevation="0" :disabled="disabled">
      <v-icon :color="iconColor">{{ icon }}</v-icon>
    </v-btn>
    <div class="d-inline-flex flex-column ml-2" style="width: 80px; white-space: nowrap; flex: 1">
      <p class="abstract-place__name">{{ title }}</p>
      <p class="abstract-place__address">{{ subtitle }}</p>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: 'AbstractCarButton',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: true,
    },
    btnColor: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<!-- TODO: the styles are repeated -->
<!-- TODO: class names are inccorrect for this component -->
<style lang="scss" scoped>
.abstract-place {
  &__container {
    display: flex;
    align-items: center;
    padding: 8px;
    column-gap: 8px;

    // override of default vuetify hover state
    // https://app.clickup.com/t/8693q3ex9 AC.1
    & .v-btn:hover::before {
      opacity: 0;
    }
  }
  &__name,
  &__address {
    margin-bottom: 0;

    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__name {
    font: 400 15px/18px 'Roboto', sans-serif;
    color: #323232;
  }
  &__address {
    font: 400 13px/15px 'Roboto', sans-serif;
    color: #5a5a5a;
  }
}
</style>
